// import go from '../assets/img/dance/go.jpeg';
import pretty_u from '../assets/img/dance/pretty_u.jpeg';
import dynamite from '../assets/img/dance/dynamite.jpeg';
import drama from '../assets/img/dance/drama.jpeg';
import monster from '../assets/img/dance/monster.jpeg';
import gogo from '../assets/img/dance/gogo.jpeg';
import go from '../assets/img/dance/cortis_go.jpeg';

const danceData = [
  {
    id: 1,
    title: "go!",
    artist: "cortis",
    image: go,
    youtubeUrl: 'https://www.youtube.com/watch?v=TGWEyvzRxyo&t=1890s',
    description: "spring 2026",
    date: "2026"
  },
  {
    id: 2,
    title: "pretty u",
    artist: "seventeen",
    image: pretty_u,
    youtubeUrl: 'https://www.youtube.com/watch?v=lPSh1pc6j8U&t=1571s',
    description: "fall 2025",
    date: "2025"
  },
    {
    id: 3,
    title: "monster",
    artist: "exo",
    image: monster,
    youtubeUrl: null,
    description: "spring 2025",
    date: "2025"
  },
  {
    id: 4,
    title: "dynamite",
    artist: "bts",
    image: dynamite,
    youtubeUrl: null,
    description: "fall 2024",
    date: "2024"
  },
  {
    id: 5,
    title: "drama",
    artist: "txt",
    image: drama,
    youtubeUrl: 'https://youtu.be/wTJEqgXBj8U?si=ju6SDgPk9GJOdXAo&t=125',
    description: "spring 2024",
    date: "2024"
  },
  {
    id: 6,
    title: "go go",
    artist: "bts",
    image: gogo,
    youtubeUrl: 'https://youtu.be/-uANlb4ovIM?si=Q6Al3v0-vBaec_v_&t=135',
    description: "fall 2023",
    date: "2023"
  },
];

export default danceData;
